import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Stack, Typography } from "@mzc-pdc/ui";
import { IconAiBuilder } from "@mzc-cloudplex/icons";
import { useTranslation } from "react-i18next";
import theme from "@styles/theme";
import AiGlossyOrb from "./ai-glossy-orb";

const PRESET_KEYS = [
    "AI Search Preset Golden sunset on the beach",
    "AI Search Preset People in a meeting at the office",
    "AI Search Preset Cinematic mood videos",
    "AI Search Preset City night view by drone",
    "AI Search Preset Children smiling brightly",
];

const AiSearchEmpty = ({ onClickSuggestion }) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                flex: 1,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                overflow: "auto",
                py: 7.5,
            }}
        >
            <Stack
                spacing={3}
                alignItems="center"
                sx={{
                    width: "100%",
                    maxWidth: 600,
                    px: 3,
                    pb: 5,
                }}
            >
                <AiGlossyOrb size={60} />
                <Box sx={{ textAlign: "center" }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            color: theme.palette.greySecondary.main,
                            fontSize: 24,
                            lineHeight: 1.5,
                        }}
                    >
                        {t(`common::label::Hi, this is AI search mode`)}
                        <br />
                        <Box component="span" sx={{ whiteSpace: "nowrap" }}>
                            {t(`common::label::Describe a scene or feature in the video you are looking for!`)}
                        </Box>
                    </Typography>
                </Box>
                <Stack spacing={1} alignItems="flex-start" sx={{ width: "100%" }}>
                    {PRESET_KEYS.map((key) => {
                        const label = t(`common::label::${key}`);
                        return (
                            <Button
                                key={key}
                                variant="text"
                                size="small"
                                startIcon={<IconAiBuilder size={16} htmlColor={theme.palette.primary[100]} />}
                                onClick={() => onClickSuggestion(label)}
                                sx={{
                                    color: theme.palette.primary.main,
                                    fontSize: 12,
                                    fontWeight: 400,
                                    lineHeight: 1.5,
                                    textTransform: "none",
                                    borderRadius: "100px",
                                    height: 24,
                                    minHeight: 24,
                                    px: 1.5,
                                    py: 0,
                                    gap: 0.5,
                                    "& .MuiButton-startIcon": {
                                        marginRight: 0,
                                        marginLeft: 0,
                                    },
                                }}
                            >
                                {label}
                            </Button>
                        );
                    })}
                </Stack>
            </Stack>
        </Box>
    );
};

AiSearchEmpty.propTypes = {
    onClickSuggestion: PropTypes.func.isRequired,
};

export default AiSearchEmpty;
